import LinKProjectItem from "./LinkProjectItem";

type LinKProjectItemProps = {
  nameProjects: string;
  madeAt: string;
  techs: string[];
  contributions: string[];
  urls: { name: string; url: string }[];
};

function ProjectRowChild(props: LinKProjectItemProps) {
  return (
    <tr className="border-b border-slate-300/10 last:border-none">
      <td className="pt-6 pb-4 pr-4 align-top leading-snug font-semibold text-[16px]">
        <div className="">{props.nameProjects}</div>
      </td>
      <td className="pt-6 pb-4 pr-4 align-top text-gray-5 font-normal">
        <div className="hidden sm:block 2xl:mt-1">{props.madeAt}</div>
      </td>
      <td className="pt-6 pb-4 align-top font-normal">
        <ul
          className={`flex flex-wrap -mt-3 text-custom-green-2 font-medium text-xs`}
        >
          {props.techs.map((tech) => (
            <li className="mr-1.5 mt-3" key={tech}>
              <div className="flex items-center rounded-full bg-teal-400/10 px-3 py-1 leading-5">
                {tech}
              </div>
            </li>
          ))}
        </ul>
      </td>
      <td className="pt-6 pb-4 pr-4 align-top text-gray-5 font-normal">
        <div className="flex flex-col">
          {props.contributions.map((contribution) => (
            <>
              {contribution == ". . ." ? (
                <div className="mb-1 flex flex-row" key={contribution}>
                  <div className="mr-2">-</div>
                  <div className="font-bold">{contribution}</div>
                </div>
              ) : (
                <div className="mb-1" key={contribution}>
                  - {contribution}
                </div>
              )}
            </>
          ))}
        </div>
      </td>
      <td className="pt-6 pb-4 pr-4 align-top ">
        <div className="flex flex-col">
          {props.urls.map((url) => (
            <LinKProjectItem name={url.name} url={url.url} />
          ))}
        </div>
      </td>
    </tr>
  );
}

export default ProjectRowChild;
